"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var Widget_1 = require("../tools/Widget");
var GoogleAnalyticsEvents = (function (_super) {
    __extends(GoogleAnalyticsEvents, _super);
    function GoogleAnalyticsEvents(node, config) {
        var _this = _super.call(this, node, config) || this;
        _this.bnrPlayerLastEvent = null;
        _this.bnrPlayerLastPayload = null;
        _this.bnrPlayerInterval = null;
        _this.duration = 0;
        _this.trackShareEmail();
        _this.trackLoginForm();
        _this.trackInternalClicks();
        _this.trackServicePageClicks();
        _this.trackSubscriptionButtonClicks();
        _this.trackLinkedInConnect();
        _this.trackGAAvailability();
        _this.trackGTMAvailability();
        return _this;
    }
    GoogleAnalyticsEvents.prototype.favoriteAdded = function (event, payload) {
        analyticsEvent('articles', 'add favorite', payload.title);
    };
    GoogleAnalyticsEvents.prototype.favoriteDeleted = function (event, payload) {
        analyticsEvent('articles', 'delete favorite', payload.title);
    };
    GoogleAnalyticsEvents.prototype.trackGAAvailability = function () {
        if (window.ga && ga.create) {
            var img = document.createElement('img');
            img.setAttribute('style', 'display:none;');
            img.src = "/pixel/ga-allowed" + (siteData.customerNumber ? '?uid=' + siteData.customerNumber : '');
            document.body.appendChild(img);
        }
        else {
            var img = document.createElement('img');
            img.setAttribute('style', 'display:none;');
            img.src = "/pixel/ga-blocked" + (siteData.customerNumber ? '?uid=' + siteData.customerNumber : '');
            document.body.appendChild(img);
        }
    };
    GoogleAnalyticsEvents.prototype.trackGTMAvailability = function () {
        if (window.google_tag_manager) {
            var img = document.createElement('img');
            img.setAttribute('style', 'display:none;');
            img.src = "/pixel/gtm-allowed" + (siteData.customerNumber ? '?uid=' + siteData.customerNumber : '');
            document.body.appendChild(img);
        }
        else {
            var img = document.createElement('img');
            img.setAttribute('style', 'display:none;');
            img.src = "/pixel/gtm-blocked" + (siteData.customerNumber ? '?uid=' + siteData.customerNumber : '');
            document.body.appendChild(img);
        }
    };
    GoogleAnalyticsEvents.prototype.keepAlive = function () {
        analyticsEvent('non-interactions', 'keep-alive', null, null, true);
    };
    GoogleAnalyticsEvents.prototype.metaRefresh = function () {
        analyticsEvent('non-interactions', 'auto-refresh', null, null, true);
    };
    GoogleAnalyticsEvents.prototype.socialShare = function (event, payload) {
        analyticsEvent('articles', payload.socialNetwork + ' share', payload.articleID);
    };
    GoogleAnalyticsEvents.prototype.commentAdded = function (event, payload) {
        analyticsEvent('articles', 'comment placed', payload.articleTitle);
    };
    GoogleAnalyticsEvents.prototype.alertAdded = function (event, payload) {
        analyticsEvent('user settings', 'activate alert', 'alert: ' + payload.key);
    };
    GoogleAnalyticsEvents.prototype.trackShareEmail = function () {
        jquery_1.default(document).on('click', '.share-email', function () {
            analyticsEvent('articles', 'E-mail share', jquery_1.default(this).attr('data-id'));
        });
    };
    GoogleAnalyticsEvents.prototype.alertDeleted = function (event, payload) {
        analyticsEvent('user settings', 'deactivate alert', 'alert: ' + payload.key);
    };
    GoogleAnalyticsEvents.prototype.trackLoginForm = function () {
        if (jquery_1.default('form.login ul.errors').length > 0) {
            analyticsEvent('forms', 'field error: ' + jquery_1.default('form.login ul.errors li').text(), 'login');
        }
        jquery_1.default(document).on('focus', 'form.login input', function () {
            analyticsEvent('forms', 'field focus: ' + jquery_1.default(this).attr('name'), 'login');
        });
        jquery_1.default(document).on('submit', 'form.login', function () {
            analyticsEvent('forms', 'login via email', 'login');
            analyticsEvent('forms', 'submit', 'login');
        });
        jquery_1.default(document).on('click', 'form.login .linkedin', function () {
            analyticsEvent('forms', 'login via linkedin', 'login');
        });
    };
    GoogleAnalyticsEvents.prototype.trackLinkedInConnect = function () {
        if (jquery_1.default('html.linkedin-connect-success').length > 0) {
            analyticsEvent('user settings', 'connect to linkedin');
        }
    };
    GoogleAnalyticsEvents.prototype.digikrantScrollToNext = function () {
        analyticsEvent('newspaper', 'navigate >');
    };
    GoogleAnalyticsEvents.prototype.digikrantScrollToPrevious = function () {
        analyticsEvent('newspaper', 'navigate <');
    };
    GoogleAnalyticsEvents.prototype.digikrantScrollToStart = function () {
        analyticsEvent('newspaper', 'navigate |<');
    };
    GoogleAnalyticsEvents.prototype.digikrantScrollToEnd = function () {
        analyticsEvent('newspaper', 'navigate >|');
    };
    GoogleAnalyticsEvents.prototype.digikrantArticleClick = function (e, url) {
        analyticsEvent('newspaper', 'article click', url);
    };
    GoogleAnalyticsEvents.prototype.digikrantZoomIn = function () {
        analyticsEvent('newspaper', 'zoom in');
    };
    GoogleAnalyticsEvents.prototype.digikrantZoomInMax = function () {
        analyticsEvent('newspaper', 'max zoom reached');
    };
    GoogleAnalyticsEvents.prototype.digikrantZoomOut = function () {
        analyticsEvent('newspaper', 'zoom out');
    };
    GoogleAnalyticsEvents.prototype.digikrantZoomOutMax = function () {
        analyticsEvent('newspaper', 'min zoom reached');
    };
    GoogleAnalyticsEvents.prototype.digikrantSectionClick = function (e, sectionId) {
        analyticsEvent('newspaper', 'section click', sectionId);
    };
    GoogleAnalyticsEvents.prototype.digikrantKbScrollToNext = function () {
        analyticsEvent('newspaper', 'keyboard navigate >');
    };
    GoogleAnalyticsEvents.prototype.digikrantKbScrollToPrevious = function () {
        analyticsEvent('newspaper', 'keyboard navigate <');
    };
    GoogleAnalyticsEvents.prototype.digikrantKbScrollToStart = function () {
        analyticsEvent('newspaper', 'keyboard navigate |<');
    };
    GoogleAnalyticsEvents.prototype.digikrantKbScrollToEnd = function () {
        analyticsEvent('newspaper', 'keyboard navigate >|');
    };
    GoogleAnalyticsEvents.prototype.digikrantKbArticleClick = function (e, url) {
        analyticsEvent('newspaper', 'keyboard article click', url);
    };
    GoogleAnalyticsEvents.prototype.loadMore = function (e, text) {
        analyticsEvent('show/load more', 'Click ' + text);
    };
    GoogleAnalyticsEvents.prototype.trackInternalClicks = function () {
        jquery_1.default(document).on('click', '#mijn-favorieten a', function () {
            analyticsEvent('internal links', 'click link', 'mijn favorieten');
        });
        jquery_1.default(document).on('click', '#recent-gelezen', function () {
            analyticsEvent('internal links', 'click link', 'recent gelezen');
        });
        jquery_1.default(document).on('click', '.program-container > .teaser > A', function () {
            analyticsEvent('recommendation', 'click on top podcasts', jquery_1.default(this).text().trim());
        });
    };
    GoogleAnalyticsEvents.prototype.trackSubscriptionButtonClicks = function () {
        jquery_1.default(document).on('click', '.upsell-button-component .button', function () {
            analyticsEvent('internal links', 'click button', jquery_1.default(this).text());
        });
    };
    GoogleAnalyticsEvents.prototype.interestAdded = function (event, payload) {
        analyticsEvent('user settings', 'add search term', payload.key);
    };
    GoogleAnalyticsEvents.prototype.interestDeleted = function (event, payload) {
        analyticsEvent('user settings', 'remove search term', payload.key);
    };
    GoogleAnalyticsEvents.prototype.trackServicePageClicks = function () {
        var that = this;
        jquery_1.default('.faq .mainsubject').on('click', function (e) {
            that.serviceAccordionOpened(e, jquery_1.default(this).text().trim());
        });
    };
    GoogleAnalyticsEvents.prototype.serviceAccordionOpened = function (event, subject) {
        analyticsEvent('faq', 'click to open', subject);
    };
    GoogleAnalyticsEvents.prototype.newsletterBreakingAlertAdded = function (event, payload) {
        analyticsEvent('user settings', 'change newsletter subscription', payload);
    };
    GoogleAnalyticsEvents.prototype.newsletterBreakingAlertDeleted = function (event, payload) {
        analyticsEvent('user settings', 'change newsletter subscription', payload);
    };
    GoogleAnalyticsEvents.prototype.beursSelectChanged = function (event, payload) {
        analyticsEvent('filter', 'click dropdown', payload);
    };
    GoogleAnalyticsEvents.prototype.beursFilterClicked = function (event, payload) {
        analyticsEvent('filter', 'click link', payload);
    };
    GoogleAnalyticsEvents.prototype.beursRadarTabClicked = function (event, payload) {
        analyticsEvent('internal links', 'click tab', payload);
    };
    GoogleAnalyticsEvents.prototype.liveVideoPlayerPlay = function (event, payload) {
        var data = this.getFragmentData();
        audioEvent("kijk", 'play', data.programName);
    };
    GoogleAnalyticsEvents.prototype.liveVideoPlayerPause = function (event, payload) {
        var data = this.getFragmentData();
        audioEvent("kijk", 'pause', payload.timeSpent, data.programName);
    };
    GoogleAnalyticsEvents.prototype.liveVideoPlayerClose = function (event, payload) {
        var data = this.getFragmentData();
        audioEvent("kijk", 'close', payload.timeSpent, data.programName);
    };
    GoogleAnalyticsEvents.prototype.liveVideoPlayerVolume = function (event, payload) {
        var data = this.getFragmentData();
        audioEvent("kijk", 'volume', payload.currentPlayerVolume + "_" + payload.newPlayerVolume, data.programName);
    };
    GoogleAnalyticsEvents.prototype.liveAudioPlayerPlay = function (event, payload) {
        var data = this.getFragmentData();
        audioEvent("luister", 'play', data.programName);
    };
    GoogleAnalyticsEvents.prototype.liveAudioPlayerPause = function (event, payload) {
        var data = this.getFragmentData();
        audioEvent("luister", 'pause', payload.timeSpent, data.programName);
    };
    GoogleAnalyticsEvents.prototype.liveAudioPlayerClose = function (event, payload) {
        var data = this.getFragmentData();
        audioEvent("luister", 'close', payload.timeSpent, data.programName);
    };
    GoogleAnalyticsEvents.prototype.liveAudioPlayerVolume = function (event, payload) {
        var data = this.getFragmentData();
        audioEvent("luister", 'volume', payload.currentPlayerVolume + "_" + payload.newPlayerVolume, data.programName);
    };
    GoogleAnalyticsEvents.prototype.determineFragmentType = function () {
        return siteData.pageName.includes('/podcast/') ? 'podcast' : 'nieuwsfragment';
    };
    GoogleAnalyticsEvents.prototype.audioFragmentPlayerPlay = function (event, payload) {
        this.determineFragmentType();
        var data = this.getFragmentData();
        audioEvent(this.determineFragmentType(), 'play', data.programName, data.programDescription);
    };
    GoogleAnalyticsEvents.prototype.audioFragmentPlayerPause = function (event, payload) {
        var data = this.getFragmentData();
        audioEvent(this.determineFragmentType(), 'pause', data.programName, data.programDescription);
    };
    GoogleAnalyticsEvents.prototype.audioFragmentPlayerClose = function (event, payload) {
        var data = this.getFragmentData();
        audioEvent(this.determineFragmentType(), 'close', payload.playerElapsed, data.programName + "_" + data.programDescription);
    };
    GoogleAnalyticsEvents.prototype.audioFragmentPlayerEnd = function (event, payload) {
        var data = this.getFragmentData();
        audioEvent(this.determineFragmentType(), 'end', payload.playerElapsed, data.programName + "_" + data.programDescription);
    };
    GoogleAnalyticsEvents.prototype.audioFragmentPlayerPercentage = function (event, payload) {
        var data = this.getFragmentData();
        audioEvent(this.determineFragmentType(), 'percentage', payload.currentPercentage, data.programName + "_" + data.programDescription);
    };
    GoogleAnalyticsEvents.prototype.audioFragmentPlayerVolume = function (event, payload) {
        var data = this.getFragmentData();
        audioEvent(this.determineFragmentType(), 'volume', payload.currentPlayerVolume + "_" + payload.newPlayerVolume, data.programName + "_" + data.programDescription);
    };
    GoogleAnalyticsEvents.prototype.audioFragmentPlayerListeningTime = function (event, payload) {
        var data = this.getFragmentData();
        audioEvent(this.determineFragmentType(), 'listeningtime', payload.timeSpent, data.programName + "_" + data.programDescription);
    };
    GoogleAnalyticsEvents.prototype.audioArchiveFragmentPlayerPlay = function (event, payload) {
        audioEvent("archief", 'play', payload.playerStarted, payload.fragmentDate + "_" + payload.playerElapsed + "_" + payload.duration);
    };
    GoogleAnalyticsEvents.prototype.audioArchiveFragmentPlayerPause = function (event, payload) {
        audioEvent("archief", 'pause', payload.playerStarted, payload.fragmentDate + "_" + payload.playerElapsed + "_" + payload.duration);
    };
    GoogleAnalyticsEvents.prototype.audioArchiveFragmentPlayerClose = function (event, payload) {
        audioEvent("archief", 'close', payload.playerStarted, payload.fragmentDate + "_" + payload.playerElapsed + "_" + payload.duration + "_" + payload.endDate);
    };
    GoogleAnalyticsEvents.prototype.audioArchiveFragmentPlayerEnd = function (event, payload) {
        audioEvent("archief", 'end', payload.playerStarted, payload.fragmentDate + "_" + payload.playerElapsed + "_" + payload.duration + "_" + payload.endDate);
    };
    GoogleAnalyticsEvents.prototype.audioArchiveFragmentPlayerVolume = function (event, payload) {
        audioEvent("archief", 'volume', payload.playerStarted, payload.fragmentDate + "_" + payload.playerElapsed + "_" + payload.duration + "_" + payload.endDate, payload.currentPlayerVolume + "_" + payload.newPlayerVolume);
    };
    GoogleAnalyticsEvents.prototype.audioArchiveFragmentListeningTime = function (event, payload) {
        var data = this.getFragmentData();
        audioEvent("archief", 'listeningtime', payload.timeSpent, data.programName + "_" + data.programDescription);
    };
    GoogleAnalyticsEvents.prototype.pollVote = function (event, payload) {
        analyticsEvent('poll', 'vote', payload.question, payload.answer);
    };
    GoogleAnalyticsEvents.prototype.defaultConfig = function () {
        return {
            eventNS: 'googleAnalytics',
            busBindings: {
                favoriteAdded: 'favorite.added',
                favoriteDeleted: 'favorite.deleted',
                socialShare: 'social.share',
                loadMore: 'pageLoader.loadMore',
                commentAdded: 'comments.added',
                digikrantScrollToNext: 'digikrant.scrollToNext',
                digikrantScrollToPrevious: 'digikrant.scrollToPrevious',
                digikrantScrollToStart: 'digikrant.scrollToStart',
                digikrantScrollToEnd: 'digikrant.scrollToEnd',
                digikrantArticleClick: 'digikrant.articleClick',
                digikrantZoomIn: 'digikrant.zoomIn',
                digikrantZoomInMax: 'digikrant.zoomInMax',
                digikrantZoomOut: 'digikrant.zoomOut',
                digikrantZoomOutMax: 'digikrant.zoomOutMax',
                digikrantSectionClick: 'digikrant.sectionClick',
                digikrantKbScrollToNext: 'digikrant.kbScrollToNext',
                digikrantKbScrollToPrevious: 'digikrant.kbScrollToPrevious',
                digikrantKbScrollToStart: 'digikrant.kbScrollToStart',
                digikrantKbScrollToEnd: 'digikrant.kbScrollToEnd',
                digikrantKbArticleClick: 'digikrant.kbArticleClick',
                alertAdded: 'alert.added',
                alertDeleted: 'alert.deleted',
                serviceAccordionOpened: 'serviceAccordion.open',
                interestAdded: 'interest.addEvent',
                interestDeleted: 'interest.deleted',
                newsletterBreakingAlertAdded: 'newsletterBreakingAlert.added',
                newsletterBreakingAlertDeleted: 'newsletterBreakingAlert.deleted',
                metaRefresh: 'metaRefresh',
                beursSelectChanged: 'beurs.selectChanged',
                beursFilterClicked: 'beurs.filterClicked',
                beursRadarTabClicked: 'beurs.radarTabClicked',
                playerPlay: 'player.play',
                playerPause: 'player.pause',
                playerClose: 'player.close',
                playerEnd: 'player.end',
                playerPercentage: 'player.percentage',
                playerVolume: 'player.volume',
                archivePlayerPlay: 'archivePlayer.play',
                archivePlayerPause: 'archivePlayer.pause',
                archivePlayerClose: 'archivePlayer.close',
                archivePlayerEnd: 'archivePlayer.end',
                archivePlayerVolume: 'archivePlayer.volume',
                liveAudioPlayerPlay: 'liveAudioPlayer.play',
                liveAudioPlayerPause: 'liveAudioPlayer.pause',
                liveAudioPlayerClose: 'liveAudioPlayer.close',
                liveAudioPlayerVolume: 'liveAudioPlayer.volume',
                liveVideoPlayerPlay: 'liveVideoPlayer.play',
                liveVideoPlayerPause: 'liveVideoPlayer.pause',
                liveVideoPlayerClose: 'liveVideoPlayer.close',
                liveVideoPlayerVolume: 'liveVideoPlayer.volume',
                audioFragmentPlayerPlay: 'audioFragmentPlayer.play',
                audioFragmentPlayerPause: 'audioFragmentPlayer.pause',
                audioFragmentPlayerClose: 'audioFragmentPlayer.close',
                audioFragmentPlayerEnd: 'audioFragmentPlayer.end',
                audioFragmentPlayerPercentage: 'audioFragmentPlayer.percentage',
                audioFragmentPlayerVolume: 'audioFragmentPlayer.volume',
                audioFragmentPlayerListeningTime: 'audioFragmentPlayer.listeningtime',
                audioArchiveFragmentPlayerPlay: 'audioArchiveFragmentPlayer.play',
                audioArchiveFragmentPlayerPause: 'audioArchiveFragmentPlayer.pause',
                audioArchiveFragmentPlayerClose: 'audioArchiveFragmentPlayer.close',
                audioArchiveFragmentPlayerEnd: 'audioArchiveFragmentPlayer.end',
                audioArchiveFragmentPlayerVolume: 'audioArchiveFragmentPlayer.volume',
                audioArchiveFragmentListeningTime: 'audioArchiveFragmentPlayer.listeningtime',
                pollVote: 'poll.vote'
            }
        };
    };
    GoogleAnalyticsEvents.prototype.getFragmentData = function () {
        return {
            programName: siteData.BNRProgramName,
            programDescription: siteData.BNRProgramDescription
        };
    };
    return GoogleAnalyticsEvents;
}(Widget_1.Widget));
exports.GoogleAnalyticsEvents = GoogleAnalyticsEvents;
